export default __webpack_public_path__ + "static/media/iconos y fecha_principal.2c095a17.png";